const initialState = {
  loading: false
};

const becomePartner = (state = initialState, action) => {
  switch (action.type) {
    case 'REGISTER_COMPANY_REQUEST':
    case 'REGISTER_COMPANY_FAILED':
    case 'REGISTER_COMPANY_SUCCESS': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default becomePartner;
